<template>
    <div :id="'flyin' + (config.id || '')" :class="config.className">
        <div :class="cssClasses" ref="flyinDialog">
            <span class="sr-only flyout-sr-only" tabindex="0" aria-hidden="true"></span>
            <button type="button" class="side--close icon-close" tabindex="0" v-show="!disableInterface" ref="flyinCloseButton" @click="shouldClose">
                <span class="sr-only">{{ resources.close }}</span>
            </button>
            <section class="generic-flyout-content flyin-component">
                <div :class="['spinner', 'black-spinner', { 'spinner-visible': showSpinner }]">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <component :is="content" v-bind="properties" @close="shouldClose"/>
            </section>
        </div>

        <transition name="backdrop-transition">
            <div class="modal-overlay flyin-component" v-show="showBackdrop" @click="shouldClose"></div>
        </transition>
    </div>
</template>

<script src="./flyin.js"></script>
